
class dom {

    static getPosition (element) {
        var top = 0, left = 0;
        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);

        return {
            top: top,
            left: left
        };
    }

    static getHighest (list) {
        let highestTop = Number.MAX_SAFE_INTEGER;
        let highestElement;

        for (let x = 0; x < list.length; x++) {
            if (highestElement) {
                let currentElement = list[x];
                let currentTop = this.getPosition(currentElement).top;
                if (currentTop < highestTop) {
                    highestElement = currentElement;
                    highestTop = currentTop;
                }
            }
            else {
                highestElement = list[x];
                highestTop = this.getPosition(highestElement).top;
            }
        }

        return highestElement;
    }

}


export default dom;

